'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserName() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_USER_LOGIN);
}

exports.default = getUserName;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/cookie/getUserName.js
// module id = 350
// module chunks = 1